// @flow
import { connect } from 'react-redux';

import HtmlElementWrapper from 'components/newsletter/blocs/HtmlElementWrapper';
import type { StateProps } from 'components/newsletter/blocs/HtmlElementWrapper';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  })
)(HtmlElementWrapper);
